import { css } from '@emotion/react';
import React, { useContext } from 'react';
import { LanguageContext } from 'src/context/language-context';
import { infoFooter } from 'src/helpers/brand-helper';
import { smallMobileThreshold } from 'src/styling/customStyles';

const ContactInfoFooter: React.FC<{}> = ({}) => {
  const { language } = useContext(LanguageContext);
  const contactInfoFooterStyle = css`
    font-size: 11px;

    p {
      text-align: center;
      margin: 6px;
    }

    h3 {
      text-align: center;
      margin: 6px;
    }

    @media (min-width: ${smallMobileThreshold}) {
      font-size: 13px;
    }
  `;

  return (
    <div css={contactInfoFooterStyle}>
      <p>{infoFooter[language]}</p>
    </div>
  );
};

export default ContactInfoFooter;
